import i18n from "@/i18n";

export const playerMonitorsFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "description",
        label: i18n.t("common.description"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];
